/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateInterviewTypeDto,
  CreateInterviewTypeVersionDto,
  InterviewTypeDetailDto,
  InterviewTypeListItemDto,
  InterviewTypeVersionDetailDto,
  ListInterviewTypesParams,
  UpdateInterviewTypeDto
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListInterviewTypesUrl = (params: ListInterviewTypesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/interview-types?${stringifiedParams}` : `/interview-types`
}

export const listInterviewTypes = async (params: ListInterviewTypesParams, options?: Parameters<typeof customFetch>[1]): Promise<InterviewTypeListItemDto[]> => {

  return customFetch<InterviewTypeListItemDto[]>(getListInterviewTypesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInterviewTypesQueryKey = (params?: ListInterviewTypesParams,) => {
    return [
    `/interview-types`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInterviewTypesQueryOptions = <TData = Awaited<ReturnType<typeof listInterviewTypes>>, TError = unknown>(params: ListInterviewTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInterviewTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInterviewTypes>>> = ({ signal }) => listInterviewTypes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInterviewTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInterviewTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listInterviewTypes>>>
export type ListInterviewTypesQueryError = unknown


export function useListInterviewTypes<TData = Awaited<ReturnType<typeof listInterviewTypes>>, TError = unknown>(
 params: ListInterviewTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInterviewTypes>>,
          TError,
          Awaited<ReturnType<typeof listInterviewTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInterviewTypes<TData = Awaited<ReturnType<typeof listInterviewTypes>>, TError = unknown>(
 params: ListInterviewTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInterviewTypes>>,
          TError,
          Awaited<ReturnType<typeof listInterviewTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInterviewTypes<TData = Awaited<ReturnType<typeof listInterviewTypes>>, TError = unknown>(
 params: ListInterviewTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListInterviewTypes<TData = Awaited<ReturnType<typeof listInterviewTypes>>, TError = unknown>(
 params: ListInterviewTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInterviewTypesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateInterviewTypeUrl = () => {




  return `/interview-types`
}

export const createInterviewType = async (createInterviewTypeDto: CreateInterviewTypeDto, options?: Parameters<typeof customFetch>[1]): Promise<InterviewTypeDetailDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InterviewTypeDetailDto>(getCreateInterviewTypeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInterviewTypeDto)
  }
);}





export const getCreateInterviewTypeMutationKey = () => ['createInterviewType'] as const;

export const getCreateInterviewTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewType>>, TError,CreateInterviewTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInterviewType>>, TError,CreateInterviewTypeMutationVariables, TContext> => {

const mutationKey = getCreateInterviewTypeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInterviewType>>, CreateInterviewTypeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createInterviewType(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInterviewTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createInterviewType>>>
    export type CreateInterviewTypeMutationBody = CreateInterviewTypeDto
    export type CreateInterviewTypeMutationError = unknown
    export type CreateInterviewTypeMutationVariables = {data: CreateInterviewTypeDto}

    export const useCreateInterviewType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewType>>, TError,CreateInterviewTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInterviewType>>,
        TError,
        CreateInterviewTypeMutationVariables,
        TContext
      > => {
      return useMutation(getCreateInterviewTypeMutationOptions(options), queryClient);
    }
    export const getGetInterviewTypeUrl = (id: string,) => {




  return `/interview-types/${id}`
}

export const getInterviewType = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<InterviewTypeDetailDto> => {

  return customFetch<InterviewTypeDetailDto>(getGetInterviewTypeUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInterviewTypeQueryKey = (id: string,) => {
    return [
    `/interview-types/${id}`
    ] as const;
    }


export const getGetInterviewTypeQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewType>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewTypeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewType>>> = ({ signal }) => getInterviewType(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInterviewTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewType>>>
export type GetInterviewTypeQueryError = unknown


export function useGetInterviewType<TData = Awaited<ReturnType<typeof getInterviewType>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewType>>,
          TError,
          Awaited<ReturnType<typeof getInterviewType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewType<TData = Awaited<ReturnType<typeof getInterviewType>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewType>>,
          TError,
          Awaited<ReturnType<typeof getInterviewType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewType<TData = Awaited<ReturnType<typeof getInterviewType>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInterviewType<TData = Awaited<ReturnType<typeof getInterviewType>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInterviewTypeQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateInterviewTypeUrl = (id: string,) => {




  return `/interview-types/${id}`
}

export const updateInterviewType = async (id: string,
    updateInterviewTypeDto: UpdateInterviewTypeDto, options?: Parameters<typeof customFetch>[1]): Promise<InterviewTypeDetailDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InterviewTypeDetailDto>(getUpdateInterviewTypeUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateInterviewTypeDto)
  }
);}





export const getUpdateInterviewTypeMutationKey = () => ['updateInterviewType'] as const;

export const getUpdateInterviewTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInterviewType>>, TError,UpdateInterviewTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInterviewType>>, TError,UpdateInterviewTypeMutationVariables, TContext> => {

const mutationKey = getUpdateInterviewTypeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInterviewType>>, UpdateInterviewTypeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateInterviewType(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInterviewTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateInterviewType>>>
    export type UpdateInterviewTypeMutationBody = UpdateInterviewTypeDto
    export type UpdateInterviewTypeMutationError = unknown
    export type UpdateInterviewTypeMutationVariables = {id: string;data: UpdateInterviewTypeDto}

    export const useUpdateInterviewType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInterviewType>>, TError,UpdateInterviewTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInterviewType>>,
        TError,
        UpdateInterviewTypeMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateInterviewTypeMutationOptions(options), queryClient);
    }
    export const getCreateInterviewTypeVersionUrl = (id: string,) => {




  return `/interview-types/${id}/versions`
}

export const createInterviewTypeVersion = async (id: string,
    createInterviewTypeVersionDto: CreateInterviewTypeVersionDto, options?: Parameters<typeof customFetch>[1]): Promise<InterviewTypeVersionDetailDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InterviewTypeVersionDetailDto>(getCreateInterviewTypeVersionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInterviewTypeVersionDto)
  }
);}





export const getCreateInterviewTypeVersionMutationKey = () => ['createInterviewTypeVersion'] as const;

export const getCreateInterviewTypeVersionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewTypeVersion>>, TError,CreateInterviewTypeVersionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInterviewTypeVersion>>, TError,CreateInterviewTypeVersionMutationVariables, TContext> => {

const mutationKey = getCreateInterviewTypeVersionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInterviewTypeVersion>>, CreateInterviewTypeVersionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createInterviewTypeVersion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInterviewTypeVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createInterviewTypeVersion>>>
    export type CreateInterviewTypeVersionMutationBody = CreateInterviewTypeVersionDto
    export type CreateInterviewTypeVersionMutationError = unknown
    export type CreateInterviewTypeVersionMutationVariables = {id: string;data: CreateInterviewTypeVersionDto}

    export const useCreateInterviewTypeVersion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewTypeVersion>>, TError,CreateInterviewTypeVersionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInterviewTypeVersion>>,
        TError,
        CreateInterviewTypeVersionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateInterviewTypeVersionMutationOptions(options), queryClient);
    }
    export const getArchiveInterviewTypeUrl = (id: string,) => {




  return `/interview-types/${id}/archive`
}

export const archiveInterviewType = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getArchiveInterviewTypeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getArchiveInterviewTypeMutationKey = () => ['archiveInterviewType'] as const;

export const getArchiveInterviewTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveInterviewType>>, TError,ArchiveInterviewTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveInterviewType>>, TError,ArchiveInterviewTypeMutationVariables, TContext> => {

const mutationKey = getArchiveInterviewTypeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveInterviewType>>, ArchiveInterviewTypeMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  archiveInterviewType(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveInterviewTypeMutationResult = NonNullable<Awaited<ReturnType<typeof archiveInterviewType>>>

    export type ArchiveInterviewTypeMutationError = unknown
    export type ArchiveInterviewTypeMutationVariables = {id: string}

    export const useArchiveInterviewType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveInterviewType>>, TError,ArchiveInterviewTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveInterviewType>>,
        TError,
        ArchiveInterviewTypeMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveInterviewTypeMutationOptions(options), queryClient);
    }
    export const getUnarchiveInterviewTypeUrl = (id: string,) => {




  return `/interview-types/${id}/unarchive`
}

export const unarchiveInterviewType = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getUnarchiveInterviewTypeUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnarchiveInterviewTypeMutationKey = () => ['unarchiveInterviewType'] as const;

export const getUnarchiveInterviewTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveInterviewType>>, TError,UnarchiveInterviewTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveInterviewType>>, TError,UnarchiveInterviewTypeMutationVariables, TContext> => {

const mutationKey = getUnarchiveInterviewTypeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveInterviewType>>, UnarchiveInterviewTypeMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unarchiveInterviewType(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveInterviewTypeMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveInterviewType>>>

    export type UnarchiveInterviewTypeMutationError = unknown
    export type UnarchiveInterviewTypeMutationVariables = {id: string}

    export const useUnarchiveInterviewType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveInterviewType>>, TError,UnarchiveInterviewTypeMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unarchiveInterviewType>>,
        TError,
        UnarchiveInterviewTypeMutationVariables,
        TContext
      > => {
      return useMutation(getUnarchiveInterviewTypeMutationOptions(options), queryClient);
    }
